export const cliente: any = {
    'ifc_maravilhas':{
        nomeCliente: 'Igreja Formosa de Cristo'
        ,instagram: '@ifc_maravilhas'
        ,avatar: require('@/assets/images/avatar-ifcmaravilhas.jpg')
        ,social:[
            { 
                thumbnail: ''
                ,alt: 'Facebook'
                ,link: 'https://fb.com/igrejafc'
            }
            ,{ 
                thumbnail: ''
                ,alt: 'Instagram'
                ,link: 'https://instagram.com/ifc_maravilhas'
            },
            { 
                thumbnail: ''
                ,alt: 'Youtube'
                ,link: 'https://youtube.com/ifcmaravilhas'
            }
        ]
        ,links:[
            {
                titulo: 'Culto de domingo | Manhã 09h'
                ,link: 'https://www.eventbrite.com.br/e/culto-de-domingo-manha-2806-09h-tickets-110991147510'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Culto de domingo | Tarde 18h'
                ,link: 'https://www.eventbrite.com.br/e/culto-de-domingo-tarde-2806-18h-tickets-110992343086'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Vídeo Novo - Retorno dos cultos'
                ,link: 'https://www.youtube.com/watch?v=jzcYxnffXts'
                ,thumbnail: ''
            }

        ]
    }
    ,'fellipearb':{
        nomeCliente: 'Fellipe Augusto Barros'
        ,instagram: '@fellipearb'
        ,avatar: require('@/assets/images/avatar-fellipearb.jpg')
        ,social:[
            { 
                thumbnail: ''
                ,alt: 'Facebook'
                ,link: 'https://fb.com/igrejafc'
            }
            ,{ 
                thumbnail: ''
                ,alt: 'Instagram'
                ,link: 'https://instagram.com/ifc_maravilhas'
            },
            { 
                thumbnail: ''
                ,alt: 'Youtube'
                ,link: 'https://youtube.com/ifcmaravilhas'
            }
        ]
        ,links:[
            {
                titulo: 'Loja de auto-peças'
                ,link: 'https://www.eventbrite.com.br/e/culto-de-domingo-manha-2806-09h-tickets-110991147510'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Portifólio'
                ,link: 'https://www.eventbrite.com.br/e/culto-de-domingo-tarde-2806-18h-tickets-110992343086'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Linkedin'
                ,link: 'https://www.youtube.com/watch?v=jzcYxnffXts'
                ,thumbnail: ''
            }

        ]
    }
    ,'nathaliaduraes_':{
        nomeCliente: 'Nathalia Durães'
        ,instagram: '@nathaliaduraes_'
        ,avatar: require('@/assets/images/avatar-nathaliaduraes_.jpg')
        ,social:[
            { 
                thumbnail: ''
                ,alt: 'Facebook'
                ,link: 'https://fb.com/igrejafc'
            }
            ,{ 
                thumbnail: ''
                ,alt: 'Instagram'
                ,link: 'https://instagram.com/ifc_maravilhas'
            },
            { 
                thumbnail: ''
                ,alt: 'Youtube'
                ,link: 'https://youtube.com/ifcmaravilhas'
            }
        ]
        ,links:[
            {
                titulo: 'Catinho da Nat'
                ,link: 'https://google.com'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Meu canal'
                ,link: 'https://youtube.com'
                ,thumbnail: ''
            }
            ,{
                titulo: 'Meu blog'
                ,link: 'https://blog.com'
                ,thumbnail: ''
            }

        ]
    }
}